import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'src/api/axiosInstance';

export const refreshTenantPreference = createAsyncThunk(
  'tenantPreference/refresh',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/rest/preferences/getData');
      const prefs = Array.isArray(response.data) ? response.data : [response.data];
      const dateFormat = prefs[0]?.dateFormat || 'DD/MM/YYYY';
      const maxSizeOfDocuments = prefs[0]?.maxSizeOfDocuments || 3;
      return { dateFormat, maxSizeOfDocuments };
    } catch (err) {
      console.error('[TenantPreference] Failed to fetch tenant preference:', err);
      return rejectWithValue(err?.response?.data?.message || 'Failed to fetch tenant preference');
    } 
  }
);
